import React from "react";
import { MultiLineRateChart } from "src/components/common/chart/MultiLineRateChart";
import { PRD5050_R01ResultDto } from "./Dto_PRD5050_R01";

// Chart 컴포넌트가 받는 props 타입
interface Props {
	data: PRD5050_R01ResultDto[]; // 월별(1~12월) 결과 리스트
}

// 월별 설비종합효율(OEE) 라인차트 컴포넌트
// - 시간가동율/양품율/성능가동율/설비종합효율 4개 지표 모두 %(퍼센트) 단위이므로
//   막대+선 콤보 대신 단일 y축(0~120%)의 순수 라인차트(공용 컴포넌트)로 표현한다.
export const Chart_PRD5050_R01: React.FC<Props> = ({ data }) => {
	return (
		<MultiLineRateChart
			data={data}
			lines={[
				{ field: "operatingRate", label: "시간가동율", color: "#3B82F6" },
				{ field: "yieldRate", label: "양품율", color: "#FB923C" },
				{ field: "performanceRate", label: "성능가동율", color: "#9CA3AF" },
				{ field: "oeeRate", label: "설비종합효율", color: "#EAB308", emphasize: true },
			]}
			yMax={120}
		/>
	);
};

export default Chart_PRD5050_R01;
